var HashMap = require("./hashMap.js");
var HashSet = require("./hashSet.js");

var Bins = function(hash) {
    this._bins = new HashMap(hash);
};

Bins.prototype.put = function(key, value) {
    var bin;
    if (this._bins.contains(key)) {
        bin = this._bins.get(key);
    } else {
        bin = new HashSet();
        this._bins.put(key, bin);
    }
    bin.add(value);
};

Bins.prototype.putAll = function(key, set) {
    var bin;
    if (this._bins.contains(key)) {
        bin = this._bins.get(key);
    } else {
        bin = new HashSet();
        this._bins.put(key, bin);
    }
    bin.addAll(set);
};

Bins.prototype.get = function(key) {
    if (!this._bins.contains(key)) return new HashSet();
    else return this._bins.get(key);
};

Bins.prototype.forEach = function(f){
    this._bins.forEach(f);
};

module.exports = Bins;
